import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let defaultConfig = {
  position: 'top-center',
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};
let defaultConfigError = {
  position: 'top-center',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

const success = (message) => {
  toast.success(message, {
    ...defaultConfig,
  });
};

const error = (message) => {
  toast.error(message, {
    ...defaultConfigError,
  });
};

const Toast = {
  success,
  error,
};

export default Toast;
